const STATUS = {
  disponivel: { label: "Disponível", dot: "bg-raiz-500", cls: "border-raiz-600/30 text-raiz-800" },
  reservado: { label: "Reservado", dot: "bg-gold-500", cls: "border-gold-500/50 text-gold-700" },
  aguardando_pagamento: { label: "Aguardando confirmação", dot: "bg-amber-500", cls: "border-amber-500/50 text-amber-700" },
  agendada: { label: "Agendada", dot: "bg-raiz-600", cls: "border-raiz-600/40 text-raiz-800" },
  confirmada: { label: "Confirmada", dot: "bg-emerald-600", cls: "border-emerald-600/40 text-emerald-800" },
  realizada: { label: "Realizada", dot: "bg-neutral-400", cls: "border-neutral-400/50 text-neutral-600" },
  cancelada: { label: "Cancelada", dot: "bg-neutral-800", cls: "border-neutral-800/40 text-neutral-700" },
  falta: { label: "Não compareceu", dot: "bg-orange-500", cls: "border-orange-500/50 text-orange-700" },
  remarcada: { label: "Remarcada", dot: "bg-gold-600", cls: "border-gold-600/50 text-gold-700" },
  bloqueado: { label: "Bloqueado", dot: "bg-red-500", cls: "border-red-500/40 text-red-700" },
  passado: { label: "Passado", dot: "bg-neutral-400", cls: "border-neutral-400/60 text-neutral-500" },
  expirado: { label: "Expirado (não pago)", dot: "bg-neutral-400", cls: "border-neutral-400/60 text-neutral-500" },
  ativo: { label: "Ativo", dot: "bg-emerald-600", cls: "border-emerald-600/40 text-emerald-800" },
  concluido: { label: "Concluído", dot: "bg-neutral-400", cls: "border-neutral-400/50 text-neutral-600" },
  cancelado: { label: "Cancelado", dot: "bg-neutral-800", cls: "border-neutral-800/40 text-neutral-700" },
};

const StatusBadge = ({ status, testId }) => {
  const s = STATUS[status] || STATUS.disponivel;
  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center gap-2 whitespace-nowrap rounded-full border px-3 py-1 text-xs font-medium ${s.cls}`}
    >
      <span aria-hidden="true" className={`h-2 w-2 rounded-full ${s.dot}`} />
      {s.label}
    </span>
  );
};

export default StatusBadge;
